/**
 * TanStack Query hooks for `invoice-status-draft-sent-paid-overdue`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	invoiceStatusDraftSentPaidOverdueQueryKeys,
	type CreateInvoiceStatusDraftSentPaidOverdueBody,
	type ListInvoiceStatusDraftSentPaidOverdueResponse,
	type InvoiceStatusDraftSentPaidOverdueRow,
} from "./api";

export function useInvoiceStatusDraftSentPaidOverdueList(): UseQueryResult<ListInvoiceStatusDraftSentPaidOverdueResponse, Error> {
	return useQuery({
		queryKey: invoiceStatusDraftSentPaidOverdueQueryKeys.list(),
		queryFn: list,
	});
}

export function useInvoiceStatusDraftSentPaidOverdueCreate(): UseMutationResult<InvoiceStatusDraftSentPaidOverdueRow, Error, CreateInvoiceStatusDraftSentPaidOverdueBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: invoiceStatusDraftSentPaidOverdueQueryKeys.all });
		},
	});
}

export function useInvoiceStatusDraftSentPaidOverdueDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: invoiceStatusDraftSentPaidOverdueQueryKeys.all });
		},
	});
}
